import { render, staticRenderFns } from "./DrivetrainsSelector.vue?vue&type=template&id=1341317c"
import script from "./DrivetrainsSelector.vue?vue&type=script&lang=js"
export * from "./DrivetrainsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports